import useSWRImmutable from 'swr/immutable';

import { ShowtimeHelpers } from 'helpers/ShowtimeHelpers';

import { prepareConditionalSwrArgs } from 'hooks/prepare-conditional-swr-args';
import { ShowtimeService } from 'services/ShowtimeService';

const useQrScans = ({ email, userId, eventId }: { email?: string; userId?: string; eventId?: string }) => {
    const swrUser = useSWRImmutable(
        ...prepareConditionalSwrArgs({
            key: ShowtimeHelpers.swr.qrScans(),
            fetcher: () => ShowtimeService.getQrScansByUser(userId!),
            condition: Boolean(userId),
        }),
    );

    const swrEmail = useSWRImmutable(
        ...prepareConditionalSwrArgs({
            key: ShowtimeHelpers.swr.qrScans(),
            fetcher: () => ShowtimeService.getQrScansByEmail(email!),
            condition: Boolean(email) && !userId,
        }),
    );

    const qrScans = swrUser?.data || swrEmail?.data || [];

    return {
        qrScans: eventId ? qrScans.filter((qrScan) => qrScan.event === eventId) : qrScans,
        isLoading: swrUser?.isLoading || swrEmail?.isLoading,
        error: swrUser?.error || swrEmail?.error,
    };
};

export { useQrScans };
